import * as appUtility from '@/util/utility.js'
import * as turf from '@turf/turf'

let dataBlockSetting= {
  "icaoID": true,
  "acID": true,
  "utc": false,
  "counter": false,
  "lat": false,
  "lon": false,
  "palt": true,
  "galt": true,
  "heading": true,
  "speed": true,
  "squwak": false
}

export const dataBlockDiv = (acState,settings)=>{
   

}
export const staticDataBlock =(value)=>{
    let speed="" , alt="" ,acID=""

    if( (value.state.acID ) && (value.state.acID.length!=0)){
        acID=value.state.acID
    }
    if(value.state.alt){
        alt=(value.state.alt.pressure) ? parseInt(value.state.alt.pressure/100) : "";   
    }
   
    if(value.state.velocity){
         speed=(value.state.velocity.speed) ? parseInt(value.state.velocity.speed) : "" ;
    }
   
    // console.log(acID+"\n"+appUtility.pad( alt,3)+" "+appUtility.pad( speed,3))
    return acID+"\n"+appUtility.pad( alt,3)+" "+appUtility.pad( speed,3);
}

export const distanceBetweenTowPointsMiles = (p1,p2)=>{
    let options = {units: 'miles'};
    let  distance = turf.distance(p1, p2, options)

    return distance
}

export const PIXEL_RATIO = ()=>{
  let ctx = document.createElement("canvas").getContext("2d"),
  dpr = window.devicePixelRatio || 1,
  bsr = ctx.webkitBackingStorePixelRatio ||
        ctx.mozBackingStorePixelRatio ||
        ctx.msBackingStorePixelRatio ||
        ctx.oBackingStorePixelRatio ||
        ctx.backingStorePixelRatio || 1;
  // console.log("--> "+dpr , bsr,(dpr / bsr))
  return dpr / bsr;
} 


export const createHiDPICanvas = (w, h, ratio)=>{
  if (!ratio) { ratio = PIXEL_RATIO(); }
    var can = document.createElement("canvas");
    can.width = w * ratio;
    can.height = h * ratio;
    can.style.width = w + "px";
    can.style.height = h + "px";
    can.getContext("2d").setTransform(ratio, 0, 0, ratio, 0, 0);
    return can;
}

export const getTileScreenCoords = (x, y, zoom) => {
    // Given tile coordinates, returns x and y pixel positions of the upper-left corner of the tile.
    let { lng, lat } = XYToLngLat(x, y, zoom);
    let screenCoords = map.project([lng, lat]);
    const pixelsX = Math.round(screenCoords.x * 100) / 100;
    const pixelsY = Math.round(screenCoords.y * 100) / 100;
    return { pixelsX, pixelsY };
  }

  export const  XYToLngLat = (x, y, zoom) => {
    // Converts x and y tile coordinates to lng and lat coordinates. This returns the NW-corner of the tile.
    let lng = x / Math.pow(2, zoom) * 360 - 180;
    let n = Math.PI - (2 * Math.PI * y) / Math.pow(2, zoom);
    let lat = -1 * (radiansToDegrees(Math.atan(Math.sinh(n))) * -1);
    return { lng, lat };
  }
  
  export const radiansToDegrees = radiansVal =>{
    return radiansVal * (180 / Math.PI);
  }